import { render } from "./HeroiconsSolidDocumentText.vue?vue&type=template&id=7925094d"
const script = {}

import exportComponent from "/Users/ace/vscode/aau/scenario-maker/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidDocumentText.vue"]])

export default __exports__